import { Badge } from './badge';
import { chooseLan } from 'src/utils/language_code';

export const StockTypeBadge = ({ stockType, nameLocal, nameEnglish }) => {
  if (!stockType) return null;

  const localized = nameLocal || nameEnglish ? chooseLan(nameLocal, nameEnglish) : null;
  const label = localized || stockType;

  return <Badge tone={stockType === 'Damaged' ? 'attention' : undefined}>{label}</Badge>;
};
